import React, { ReactNode } from 'react';
import './Text.scss';
import clsx, { ClassValue } from 'clsx';

type Input = {
    children: ReactNode;
    className?: ClassValue;
    variant?: 'subtitle' | 'title';
    color?: 'textSecondary' | 'primary' | 'secondary';
    weight?: 'bolder' | 'bold';
    align?: 'left' | 'center' | 'right';
    oneLine?: boolean;
};

export function Text({ children, variant, color, className, weight, align, oneLine }: Input) {
    return (
        <div
            className={clsx(
                'MG-Text',
                variant,
                className,
                color && `c-${color}`,
                weight && `w-${weight}`,
                align && `a-${align}`,
                {
                    oneLine,
                },
            )}>
            {children}
        </div>
    );
}
